import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
  borderColor: string;
};
export const LineDotted = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(15);
  let backgroundColor;
  let borderColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      borderColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = borderColor;
    $[3] = props;
  } else {
    backgroundColor = $[1];
    borderColor = $[2];
    props = $[3];
  }
  let t1;
  let t2;
  let t3;
  if ($[4] !== backgroundColor || $[5] !== borderColor) {
    t1 = <rect x="5.5" y="10.5" width="3" height="3" rx="1.5" fill={backgroundColor} stroke={borderColor} />;
    t2 = <rect x="10.5" y="10.5" width="3" height="3" rx="1.5" fill={backgroundColor} stroke={borderColor} />;
    t3 = <rect x="15.5" y="10.5" width="3" height="3" rx="1.5" fill={backgroundColor} stroke={borderColor} />;
    $[4] = backgroundColor;
    $[5] = borderColor;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}{t2}{t3}</svg>;
    $[9] = props;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
});